export default __webpack_public_path__ + "static/media/timeline.18b72f62.png";